import { RelatedDocumentsState } from '@/types/store/RelatedDocumentsState';
import { ActionTree } from 'vuex';
import { RootState, DocumentSearchModel, RelatedDocumentsModel, StoreConstants } from '@/types';
import { RelatedDocumentsService } from '@/services/RelatedDocumentsService';
import { DateUtils } from '@/utils';

export const actions: ActionTree<RelatedDocumentsState, RootState> = {
  [StoreConstants.RelatedDocuments.Actions.GetRelatedDocuments]({ commit, getters }, documentSearchModel: DocumentSearchModel) {
    if (!getters.isLoading) {
      commit('LOADING');
      RelatedDocumentsService.getRelatedDocumentsAsync(documentSearchModel).then(
        (response: RelatedDocumentsModel) => {
          addDateFormatter(response);
          const payload: RelatedDocumentsModel = response;
          commit('RELATED_DOCUMENTS_LOADED', payload);
        },
        (error: any) => {
          commit('RELATED_DOCUMENTS_ERROR', error);
        }
      );
    }
  },
  unloadRelatedDocuments({ commit }) {
    commit('UNLOAD_RELATED_DOCUMENTS');
  },
  setRelationshipBeingViewed({ commit }, linkId: number) {
    commit('RELATIONSHIP_BEING_VIEWED', linkId);
  },
  updateDocumentDataPageCount({ commit }, { docId, change }) {
    commit('UPDATE_DOCUMENT_PAGE_COUNT', { docId, change });
  }
};

function addDateFormatter(this: any, relatedDocuments: RelatedDocumentsModel) {
  relatedDocuments.columns.forEach((column) => {
    if (column.key === 'cb_docdate') {
      column.formatter = DateUtils.formatDateWithoutTime;
    }
  });
}
